import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/procedimento`

    return {
        datatable(queryParms) {

            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        create(queryParms) {

            return repository.get(`${baseUrl}/create?${urlUtil.serialize(queryParms)}`)
        },
        store(params) {

            return repository.post(`${baseUrl}`, params)
        },
        edit(id, queryParms) {

            return repository.get(`${baseUrl}/${id}/edit?${urlUtil.serialize(queryParms)}`)
        },
        update(id, params) {

            return repository.put(`${baseUrl}/${id}`, params)
        },
        destroyAutomaticos(unidadeId, competenciaId) {

            return repository.delete(`${baseUrl}/automatico/${unidadeId}/${competenciaId}`)
        },
        destroy(id) {

            return repository.delete(`${baseUrl}/${id}`)
        },
    }
}